export function setSumLabels(datasets, ctx) {
  let sum = 0;
  datasets.map((dataset) => {
    sum += dataset.data[ctx.dataIndex];
  });

  return sum;
}

export function setDatasets(ctx) {
  return ctx.chart.data.datasets.filter((ds) => {
    if (ds._meta[0]) {
      return !ds._meta[0].hidden;
    }
    return true;
  });
}

export function getMaxTotal(arrayData) {
  return  Math.max(...arrayData);
}

export function declOfNum(number, titles) {
  let cases = [2, 0, 1, 1, 1, 2];
  return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}
